module.exports = __webpack_public_path__ + "img/red-resources-banner.e8dd5a30.png";